import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledCropperModal = styled(Modal)`
  .cropper-modal-container {
    position: relative;
    width: 100%;
    height: 400px;
  }

  .cropper-modal-title {
    color: ${(props) => props.theme.colorPrimary};
    font-weight: 600;
    font-size: 18px;
    line-height: 1.4444444444444444;
    align-self: start;
  }

  .ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .cropper-maodal-slider-wrapper {
      display: flex;
      width: 50%;
      gap: 10px;

      .ant-slider {
        width: 50%;
      }
    }
  }
`;
